var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list)?_c('AddEditList',{attrs:{"editMode":true,"list":_vm.list}}):_vm._e(),(_vm.error)?_c('span',[_vm._v("Can't find that list or something went wrong")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }